import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import React from "react";
import { ui } from "../../interfaces/interfaces";
import Paper from "@mui/material/Paper";
import useDebugInformation from "../../hooks/useDebugInformation";
import { useAppSelector } from "@store/hooks";

const closeModal = () => ui.CarePlanPaymentDirectDebitModal = false

type Props = {
  prefix: "CarePlanPaymentBankDetails";
}

const DirectDebitDialog: React.FC<Props> = ({ prefix }) => {
  const modal = useAppSelector(({ ui }) => ui.CarePlanPaymentDirectDebitModal)
  useDebugInformation("DirectDebitDialog", { modal })
  return (
    <Dialog open={modal} onClose={closeModal} aria-labelledby="form-dialog-title" maxWidth="xl">
      <DialogTitle id="form-dialog-title">Direct Debit Guarantee</DialogTitle>
      <DialogContent dividers>
        <DialogContentText></DialogContentText>
        <Paper elevation={4} sx={{ maxWidth: "90ch" }}>
          <ul style={{ margin: 5, paddingBlock: 15 }}>
            <li>The Guarantee is offered by all banks and building societies that accept instructions to pay Direct Debits</li>
            <li>If there are any changes to the amount, date or frequency of your Direct Debit the organisation will notify you (normally 10 working days) in advance of your account being debited or as otherwise agreed. If you request the organisation to collect a payment, confirmation of the amount and date will be given to you at the time of the request</li>
            <li>If an error is made in the payment of your Direct Debit, by the organisation or your bank or building society, you are entitled to a full and immediate refund of the amount paid from your bank or building society</li>
            <li>If you receive a refund you are not entitled to, you must pay it back when the organisation asks you to</li>
            <li>You can cancel a Direct Debit at any time by simply contacting your bank or building society. Written confirmation may be required. Please also notify the organisation.</li>
          </ul>
        </Paper >
      </DialogContent>
      <DialogActions>
        <Button onClick={closeModal} color="secondary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default React.memo(DirectDebitDialog)